// material
import { styled } from "@mui/material/styles";
import { Box, Typography, Grid, Paper } from "@mui/material";
import MContainer from "components/MContainer";
import { Tweet } from 'react-twitter-widgets';

// ----------------------------------------------------------------------
const SectionTitle = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  marginBottom: theme.spacing(5),
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-10px',
    left: '0',
    width: '60px',
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  }
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '750px',
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    margin: '0',
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '-28px',
  top: '-35px',
  color: theme.palette.primary.lighter,
  opacity: 0.6,
  zIndex: 0,
  '& svg': {
    width: '70px',
    height: '70px',
  },
}));

const TweetContainer = styled(Paper)(({ theme }) => ({
  borderRadius: '16px',
  boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
  height: '100%',
  position: 'relative',
}));

export default function AboutUs() {
  return (
    <MContainer 
      id="about" 
      className="paddedSection" 
      sx={{ 
        position: "relative", 
        mt: 15,
        pt: 7, 
        pb: 8,
        backgroundColor: '#f8f9fa'
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Desktop Layout (md+) */}
        <Grid 
          item 
          xs={12} 
          md={5} 
          sx={{ 
            display: { xs: 'none', md: 'block' },
            order: { xs: 2, md: 1 }
          }}
        >
          <TweetContainer>
            <Tweet 
              tweetId='1879284285636784258' 
              options={{
                height: '410',
                cards: 'hidden',
                conversation: 'none',
              }}
            />
          </TweetContainer>
        </Grid>
        
        <Grid 
          item 
          xs={12} 
          md={7} 
          sx={{ 
            order: { xs: 1, md: 2 }
          }}
        >
          <Box sx={{ position: 'relative', ml: { xs: 0, md: 5 } }}>
            <ContentWrapper>
              <SectionTitle variant="h2" color="text.primary">
                About Us
              </SectionTitle>
              
              <Typography variant="body1" color="text.secondary" sx={{ mt: 3, mb: 2.5 }}>
                We simplify procurement by sourcing everything you need while helping you make informed decisions, from picking the right printer to managing comprehensive installation projects. Our dedicated team ensures an exceptional experience with custom quotes and straightforward billing.
              </Typography>
              
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2.5 }}>
                Every customer receives a dedicated sales representative supported by an expert ordering team. Our commitment to speed means you receive quotes as quickly as possible, ensuring smooth transactions and personalized service tailored to your agency's specific procurement policies.
              </Typography>
              
              <Typography variant="body1" color="text.secondary">
                By choosing our small business, you empower a team of exceptionally friendly and highly motivated individuals, many of whom have disabilities.
              </Typography>
            </ContentWrapper>
          </Box>
        </Grid>
        
        {/* Mobile Layout (xs-sm) */}
        <Grid 
          item 
          xs={12} 
          sx={{ 
            display: { xs: 'block', md: 'none' },
            order: 3,
            mt: 2
          }}
        >
          <TweetContainer>
            <Tweet 
              tweetId='1628899013000065024' 
              options={{
                cards: 'hidden',
                conversation: 'none',
              }}
            />
          </TweetContainer>
        </Grid>
      </Grid>
    </MContainer>
  );
}
